import { useEffect, useRef } from 'react';
import { Logic } from '../../logic/logic';

interface Props {
    logic: Logic;
}

const MapModule = (props: Props) => {
    const mapContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        mapContainer.current && props.logic.map().init(mapContainer.current);
    }, []);

    return <div ref={mapContainer} className="map-container" />;
};

export default MapModule;
